import React from 'react'
import { SvgIcon } from '@material-ui/core'

const GrdIcon = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
       <path d="M7.875 19C8.17405 19.0001 8.41602 19.2429 8.41602 19.542C8.41602 19.8411 8.17405 20.0839 7.875 20.084H3.54102C3.24205 20.0838 3 19.841 3 19.542C3 19.243 3.24205 19.0002 3.54102 19H7.875ZM12.208 14.667C12.5072 14.667 12.75 14.9098 12.75 15.209C12.7498 15.508 12.5071 15.75 12.208 15.75H7.875C7.57595 15.75 7.33318 15.508 7.33301 15.209C7.33301 14.9098 7.57585 14.667 7.875 14.667H12.208ZM16.541 10.334C16.8401 10.334 17.0828 10.576 17.083 10.875C17.083 11.1742 16.8402 11.417 16.541 11.417H12.208C11.9089 11.4169 11.666 11.1741 11.666 10.875C11.6662 10.576 11.909 10.334 12.208 10.334H16.541ZM20.875 6C21.174 6.00013 21.416 6.24292 21.416 6.54199C21.416 6.84107 21.174 7.08386 20.875 7.08398H16.541C16.2421 7.08376 16 6.84101 16 6.54199C16 6.24298 16.2421 6.00022 16.541 6H20.875Z" />
    </SvgIcon>
  )
}

export default GrdIcon
